import React from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { useAppendBonusShareHistoryMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { Form as FormLayout } from "react-bootstrap";
import TextInput from "../../../Common/components/text-input";
import DateInput from "../../../Common/components/date-input";
import Skeleton from "react-loading-skeleton";

const CreateBonusSharePaymentModal = ({ showCreateBonusSharePaymentModal, instrumentId, symbol, onHide }) => {
    const [
        appendBonusShareHistory,
        {
            isLoading,
        }
    ] = useAppendBonusShareHistoryMutation()

    const validationSchema = Yup.object({
        quantity: Yup.number().min(0.1).required('Required'),
        shareBasis: Yup.number().min(0.1).required('Required'),
        qualificationDate: Yup.date().required('Required')
    })

    return (
        <Modal
            show={showCreateBonusSharePaymentModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isLoading ? "static" : true}
            keyboard={!isLoading}
        >
            <Formik
                initialValues={{
                    quantity: 0.0,
                    shareBasis: 0.0,
                    qualificationDate: "",
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    appendBonusShareHistory({ instrumentId, ...values })
                        .unwrap()
                        .then(() => {
                            cogoToast.success("Bonus Share Payment Created Successfully")
                            onHide()
                        })
                }}
            >
                {
                    ({ isValid }) => (
                        <Form>
                            <Modal.Header>
                                <Modal.Title id="contained-modal-title-vcenter">
                                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                                        <SVG
                                            title=""
                                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Safe.svg")}
                                        />
                                    </span>
                                    New {symbol ? symbol : <div style={{ width: "100px" }}><Skeleton count="1" /></div>} Bonus Share Payment
                                </Modal.Title>
                                <button type="button" className="close" onClick={onHide}>
                                    <span aria-hidden="true" className="d-block">×</span>
                                    <span className="sr-only">Close</span>
                                </button>
                            </Modal.Header>
                            <Modal.Body
                                className="px-10 py-2"
                            >
                                <fieldset disabled={isLoading}>
                                    <label className={"capitalize text-sm"}>Bonus Shares*</label>
                                    <FormLayout.Row>
                                        <TextInput
                                            name="quantity"
                                            type="number"
                                            step="any"
                                            min="0.0"
                                        />
                                        <div className="form-group d-flex align-items-center px-2"> for </div>
                                        <TextInput
                                            name="shareBasis"
                                            type="number"
                                            step="any"
                                            min="0.0"
                                        />
                                    </FormLayout.Row>
                                    <FormLayout.Row>
                                        <DateInput
                                            label="Qualification Date*"
                                            name="qualificationDate"
                                        />
                                    </FormLayout.Row>
                                </fieldset>
                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    type="button"
                                    onClick={onHide}
                                    className="btn btn-light btn-elevate px-4"
                                    disabled={isLoading}
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary btn-elevate px-4 ml-4"
                                    disabled={isLoading || !isValid}
                                >
                                    Create
                                </button>
                            </Modal.Footer>
                        </Form>
                    )}
            </Formik>
        </Modal>
    );
}

export default CreateBonusSharePaymentModal;